"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecentSearchSpacer = exports.RecentSearchListDiv = exports.RecentSearchHeaderDiv = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.RecentSearchHeaderDiv = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 20px 20px 10px;

  .Recent__List__Title {
    font-size: 0.9375rem;
    font-weight: 500;
    letter-spacing: -0.0469rem;
    color: #202020;
  }

  .Recent__List__Clear {
    font-size: 0.875rem;
    letter-spacing: -0.0437rem;
    color: #9e9e9e;
  }
`;
exports.RecentSearchListDiv = styled_components_1.default.div `
  .Auto__Complete__Item {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .Auto__Complete__Item__Img {
    width: 15px !important;
    height: 20px !important;
  }
`;
exports.RecentSearchSpacer = styled_components_1.default.div `
  width: 100%;
  padding-bottom: 10px;
`;
